import { render, staticRenderFns } from "./ListApis.vue?vue&type=template&id=24c87484"
import script from "./ListApis.vue?vue&type=script&lang=js"
export * from "./ListApis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports